import React from 'react';
import { useTranslation } from 'react-i18next';

import Page, { PageSection } from 'cityads-v3/components/Page';
import Balaclava from 'cityads-v3/components/Balaclava';
import ContactFormPageSection from 'cityads-v3/components/Forms/ContactFormPageSection';
import Typography from '@mui/material/Typography';

import classes from './Contacts.scss';

export default function Contacts(): JSX.Element {
  const { t } = useTranslation(['About'])

  return (
    <>
      <Balaclava
        menuValue={'contacts'}
      />

      <Page
        className="vcard"
        title={t('contacts.title')}
        subTitle={t('contacts.subtitle')}
        backgroundColor="#469ddf"
        backgroundImage={require('./bg.jpg')}
        pageTitle={t('contacts.title')}
        pageDescription={t('contacts.pageDescription')}
        pageKeywords={t('contacts.keywords')}
      >
        <ContactFormPageSection />

        <PageSection
          title={t('contacts.title')}
          data-as-is={true}
        >
          <Typography variant="body1">
            {t('contacts.description')}
          </Typography>

          <div className={classes.contactList}>
            <div className={classes.contactItemWorld}>
              <h3 className={classes.contactHeader}>
                {t('contacts.international')}
              </h3>
              <div className={classes.contactContent}>
                <Typography
                  color="textSecondary"
                  component="a"
                  className="email"
                  href="mailto:international@cityads.com"
                >
                  international@cityads.com
                </Typography>
              </div>
            </div>

            <div className={classes.contactItemEurope}>
              <h3 className={classes.contactHeader}>
                {t('contacts.europe')}
              </h3>
              <div className={classes.contactContent}>
                <Typography
                  color="textSecondary"
                  component="a"
                  className="email"
                  href="mailto:europe@cityads.com"
                >
                  europe@cityads.com
                </Typography>
              </div>
            </div>

            <div className={classes.contactItemAmerica}>
              <h3 className={classes.contactHeader}>
                {t('contacts.latam')}
              </h3>
              <div className={classes.contactContent}>
                <Typography
                  color="textSecondary"
                  component="a"
                  className="email"
                  href="mailto:latam@cityads.com"
                >
                  latam@cityads.com
                </Typography>
              </div>
            </div>

            <div className={classes.contactItemAsia}>
              <h3 className={classes.contactHeader}>
                {t('contacts.asia')}
              </h3>
              <div className={classes.contactContent}>
                <Typography
                  color="textSecondary"
                  component="a"
                  className="email"
                  href="mailto:vietnam@cityads.com"
                >
                  vietnam@cityads.com
                </Typography>
              </div>
            </div>

            {/*
              <div className={classes.contactItemCIS}>
                <h3 className={classes.contactHeader}>
                  {t('contacts.russia')}
                </h3>
                <div className={classes.contactContent}>
                  <Typography
                    color="textSecondary"
                    component="a"
                    className = "email"
                    href      = "mailto:russia@cityads.com"
                  >
                    russia@cityads.com
                  </Typography>
                  <div className={classes.contactContent__phone}><a href="tel:+74955405167">+7(495)540-51-67</a></div>
                </div>
              </div>
              */}

            <div className={classes.contactItemGlobal}>
              <h3 className={classes.contactHeader}>
                {t('contacts.global')}
              </h3>
              <div className={classes.contactContent}>
                <Typography
                  color="textSecondary"
                  component="a"
                  className="email"
                  href="mailto:dpo@cityads.com"
                >
                  dpo@cityads.com
                </Typography>
              </div>
            </div>
          </div>
        </PageSection>

        {/*t('contacts.addressString') ?
            (
              <Trans
                t       = {t}
                i18nKey = "contacts.addressString"
                parent  = ""
                components = {{
                  sect  : <PageSection className={classes.address} title={t('contacts.address')} />,
                  orgurl: <a className="fn org url" href="https://www.cityads.com">content</a>,
                  paddr : <p className="adr" />,
                  saddr : <span className="street-address"/>,
                  pcode : <span className="postal-code"/>,
                  loc   : <span className="locality"/>,
                  cname : <span className="country-name"/>,
                }}
              >
                <sect>
                  <orgurl>CityAds Media</orgurl>

                  <paddr>
                    <saddr>street</saddr>
                    <pcode>postal code</pcode>
                    <loc>locality</loc>
                    <cname>country</cname>
                  </paddr>
                </sect>
              </Trans>
            ) :
            null
          */}
      </Page>
    </>
  )
}
